import Row from '~shared/components/MuiGrid/Row'
import Col from '~shared/components/MuiGrid/Col'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, useMediaQuery, useTheme } from '@mui/material'
import { MultiStepFormContext } from '~shared/components/reactHookForm/MultiStepForm/MultiStepFormContext'
import { useMultiStepButtonsStyles } from '~shared/components/reactHookForm/MultiStepForm/MultiStepFormButtons/MultiStepFormButtonsStyles'
import { MultiStepFormProps } from '~shared/components/reactHookForm/MultiStepForm/useMultiStepForm'
import { useGlobalStyles } from '~shared/styles/globalStyles'
import clsx from 'clsx'

const MultiStepFormButtons: React.FC = () => {
  const s = useMultiStepButtonsStyles()
  const gs = useGlobalStyles()
  const { t } = useTranslation()
  const { handleOnClickPrevStep, handleResetForm, stepLabels, activeStepIndex } = useContext(MultiStepFormContext)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))

  const isLastStep = activeStepIndex === (stepLabels.length - 1)
  const isSuccessScreen = activeStepIndex > (stepLabels.length - 1)

  return !isSuccessScreen
    ? <Row spacingTop={3}>
      <Col xs={12} className={s.container}>
        <div>
          {
            handleResetForm
            && <Button
              variant='outlined'
              color='secondary'
              onClick={handleResetForm}
              className={clsx(gs.marginTopSmall, gs.marginBottomSmall, gs.roundCornersTop, gs.roundCornersBottom, gs.alignTextCenter)}
            >
              {t('form:reset')}
            </Button>
          }
        </div>
        <div>
          {
            (activeStepIndex > 0)
              && <Button
                variant='outlined'
                color='secondary'
                onClick={handleOnClickPrevStep}
                className={clsx(gs.marginTopSmall, gs.marginBottomSmall, gs.roundCornersTop, gs.roundCornersBottom, gs.alignTextCenter)}
              >
                {isMobile ? '←' : t('form:back')}
              </Button>
          }
          <Button
            variant='contained'
            color='secondary'
            type='submit'
            className={clsx(gs.marginTopSmall, gs.marginBottomSmall, gs.roundCornersTop, gs.roundCornersBottom, gs.alignTextCenter)}
            style={{ color: '#FFFFFF' }}
          >
            {
              isMobile ? '→' : isLastStep ? t('form:submit') : t('form:next')
            }
          </Button>
        </div>

      </Col>
    </Row>
    : null
}

export default MultiStepFormButtons
